import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { PCTypes, RetailOptionType } from "@/types/db/product-category";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import BookingModule from "@/store/modules/booking";
import { convertDateToLocale, formatDateTime, formattedDate } from "@/utils/helpers/dates";
import { CARD_IMAGE_WIDTH, CARD_IMAGE_HEIGHT, CARD_IMAGE_MEASUREMENT_UNIT } from "@/constants/style";
import { sellOnSoldOut } from "@/utils/helpers/product-category";
import { getPriceNonAutomaticAddons } from "@/utils/vue-helpers/product-slot-state";
import { addToBasket, allowSharedStocksOverBooking, isProductAvailable, isSalesPeriod, isSharedStocksWithOverbooking, selectPC } from "@/utils/vue-helpers/product-category";
import { hasAddonsEnabled } from "@/utils/vue-helpers/addons";
import SeatingPlan from "@/components/modal/seating-plan/SeatingPlan.vue";
import { closeChartInCustomerDisplay } from "@/utils/vue-helpers/customer-display";

var __default__ = defineComponent({
  name: "Card",
  components: {
    SeatingPlan: SeatingPlan
  },
  props: {
    product: {
      required: true,
      type: Object
    },
    didScroll: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(props) {
    // console.log("hi from Card setup");
    // console.log("props");
    // console.log(props);

    /**
     * Takes a date in a string format and returns it as 31 Jan. 2020 13:00
     */
    // function formattedDate(date: string): string {
    //   const d = new Date(date);
    //   if (d) {
    //     return (
    //       d.getDate() +
    //       " " +
    //       d.toLocaleString("default", { month: "short" }) +
    //       ". " +
    //       d.getFullYear() +
    //       " " +
    //       (d.getHours() > 9 ? d.getHours() : "0" + d.getHours().toString()) +
    //       ":" +
    //       (d.getMinutes() > 9
    //         ? d.getMinutes()
    //         : "0" + d.getMinutes().toString())
    //     );
    //   }
    //   return date;
    // }
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var clickPeriod = ref(0);
    var startTime = ref(0);
    var endTime = ref(0);
    var isStillPressed = ref(false);
    var showSeatingChart = ref(false);
    var isRetail = computed(function () {
      return props.product.type === PCTypes[PCTypes.Retail];
    });
    var isSeatingTicket = computed(function () {
      return props.product.type === PCTypes[PCTypes.Seated];
    });
    var sharedStocksWithOverbooking = computed(function () {
      // For FlipLab, we allow overbookings, but wz show Not Available flag on the card
      return isSharedStocksWithOverbooking(props.product);
    });
    var hasOnePrice = computed(function () {
      var _props$product$prices;

      return props.product.prices && ((_props$product$prices = props.product.prices) === null || _props$product$prices === void 0 ? void 0 : _props$product$prices.length) === 1;
    });
    var noOptionRetail = computed(function () {
      return props.product.prices && props.product.prices[0].retail && props.product.prices[0].retail.length === 1 && props.product.prices[0].retail[0].type === RetailOptionType.Default_Retail_Option;
    });
    var productPicture = computed(function () {
      // return !isRetail.value
      //   ? props.product.pictureUrl
      //   : require(`@/assets/images/icons/shopping-icon.png`);
      return props.product.pictureUrl;
    });
    var pricesArray = computed(function () {
      var _props$product$prices2;

      // If seating plan then we consider sub-categories prices
      // If not seating plan then we consider the product proces
      if (props.product.type === PCTypes[PCTypes.Seated]) {
        if (props.product.seatedSubs && props.product.seatedSubs.length) return props.product.seatedSubs.map(function (pc) {
          return pc.prices;
        }).flat().map(function (it) {
          return it.value / 100;
        });
      }

      return (_props$product$prices2 = props.product.prices) === null || _props$product$prices2 === void 0 ? void 0 : _props$product$prices2.map(function (it) {
        return it.value / 100;
      });
    });
    var getCurrentAvailability = computed(function () {
      return isProductAvailable(props.product);
    });
    var allowSelectProduct = computed(function () {
      var condition = isSalesPeriod(props.product) && clickPeriod.value < 1000 && (getCurrentAvailability.value > 0 || //for products that can be sold on 0 zero stock checking that the stock is equal to null or less
      getCurrentAvailability.value <= 0 && (sellOnSoldOut(props.product.prices, props.product.type) || sharedStocksWithOverbooking.value));
      return condition || allowSharedStocksOverBooking(props.product)
      /* ||
      isSeatingTicket.value*/
      ;
    }); // console.log("allowSelectProduct.value");
    // console.log(allowSelectProduct.value);
    // console.log("isSalesPeriod(props.product)");
    // console.log(isSalesPeriod(props.product));
    //

    function refreshPeriod(event) {
      ModalModule.setStatus(ModalStatus.Hidden);
      clickPeriod.value = 0;
      startTime.value = Date.now();
      isStillPressed.value = true;
      setTimeout(handleLongClick, 1000);
    }

    function handleLongClick() {
      // Long clicks should not show PCSelect when the ticket is a seating plan
      // it will eventually show seating popup
      if (isSeatingTicket.value) {
        return;
      } // After 1000 milliseconds, if the user is still holding and there are availabilities then we show pcSelect
      // or if the the pc is retail and it has sellOnSoldOut option.
      // Otherwise we do nothing
      // if the user is trying to scroll let's ignore the long click


      if (props.didScroll) return;

      if (isSalesPeriod(props.product) && isStillPressed.value && (getCurrentAvailability.value > 0 || getCurrentAvailability.value <= 0 && (sellOnSoldOut(props.product.prices, props.product.type) || sharedStocksWithOverbooking.value))) {
        // Selecting the PSC and showing the popup
        // ModalModule.setStatus(ModalStatus.Hidden);
        var _props$product = props.product,
            productCategory_ID = _props$product.productCategory_ID,
            timeslot_ID = _props$product.timeslot_ID;

        if (productCategory_ID && (isRetail || timeslot_ID)) {
          if (timeslot_ID) {
            BookingModule.selectTSID(timeslot_ID);
          }

          BookingModule.selectPCID(productCategory_ID);
        }

        ModalModule.setStatus(ModalStatus.PCSelect);
      } else return;
    }

    function stopPeriod(_x) {
      return _stopPeriod.apply(this, arguments);
    }

    function _stopPeriod() {
      _stopPeriod = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var productCategorySelectRes, _props$product$prices3, pssQuantity, pc, price, pssAddons;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!props.didScroll) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!isSeatingTicket.value) {
                  _context.next = 5;
                  break;
                }

                // if (allowSelectProduct.value) {
                showSeatingPopup(); //   return;
                // }

                return _context.abrupt("return");

              case 5:
                event.preventDefault();
                endTime.value = Date.now();
                clickPeriod.value = endTime.value - startTime.value;
                isStillPressed.value = false;

                if (allowSelectProduct.value) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                _context.next = 13;
                return selectPC(props.product, isRetail.value);

              case 13:
                productCategorySelectRes = _context.sent;

                if (!(productCategorySelectRes && productCategorySelectRes.pssQuantity)) {
                  _context.next = 24;
                  break;
                }

                pssQuantity = productCategorySelectRes.pssQuantity;
                pc = productCategorySelectRes.pc; // addons

                price = (_props$product$prices3 = props.product.prices) !== null && _props$product$prices3 !== void 0 && _props$product$prices3.length ? props.product.prices[0] : null;
                _context.next = 20;
                return getPriceNonAutomaticAddons(price);

              case 20:
                pssAddons = _context.sent;

                if (pssAddons.length && hasAddonsEnabled.value) {
                  // if product has addons, we display PCSelect to allow selecting quantities
                  ModalModule.setStatus(ModalStatus.PCSelect);
                } else {
                  addToBasket({
                    selectedProduct: props.product,
                    pssQuantity: pssQuantity,
                    isRetail: isRetail.value,
                    productCategory: pc
                  });
                } //


                _context.next = 25;
                break;

              case 24:
                ModalModule.setStatus(ModalStatus.PCSelect);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _stopPeriod.apply(this, arguments);
    }

    var cardPictureWidth = computed(function () {
      return {
        width: CARD_IMAGE_WIDTH + CARD_IMAGE_MEASUREMENT_UNIT,
        height: CARD_IMAGE_HEIGHT + CARD_IMAGE_MEASUREMENT_UNIT
      };
    });
    var seatingDataToChartComponent = computed(function () {
      return props.product;
    });

    function showSeatingPopup() {
      // alert("showing seating popup");
      showSeatingChart.value = true;
    }

    function isUnavailbleOrSoldOutText(product) {
      if ((!getCurrentAvailability.value || getCurrentAvailability.value < 0) && !sellOnSoldOut(product.prices, product.type)) {
        return t("field.sold-out");
      }

      return t("common.not-available");
    }

    return {
      t: t,
      formattedDate: formattedDate,
      convertDateToLocale: convertDateToLocale,
      selectPC: selectPC,
      isRetail: isRetail,
      cardPictureWidth: cardPictureWidth,
      productPicture: productPicture,
      pricesArray: pricesArray,
      hasOnePrice: hasOnePrice,
      noOptionRetail: noOptionRetail,
      RetailOptionType: RetailOptionType,
      refreshPeriod: refreshPeriod,
      stopPeriod: stopPeriod,
      sellOnSoldOut: sellOnSoldOut,
      formatDateTime: formatDateTime,
      getCurrentAvailability: getCurrentAvailability,
      isSalesPeriod: isSalesPeriod,
      sharedStocksWithOverbooking: sharedStocksWithOverbooking,
      isSeatingTicket: isSeatingTicket,
      showSeatingChart: showSeatingChart,
      seatingDataToChartComponent: seatingDataToChartComponent,
      isUnavailbleOrSoldOutText: isUnavailbleOrSoldOutText
    };
  },
  mounted: function mounted() {// console.log("hi from mounted");
    // console.log("this.props.product");
    // console.log(this.$props.product);
  },
  methods: {
    updateShowSeatingChart: function updateShowSeatingChart() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.showSeatingChart = false; // TODO Hamza: broadcast a message to close customerChart modal

                _context2.next = 3;
                return closeChartInCustomerDisplay({});

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
});

import { useCssVars as _useCssVars } from 'vue';

var __injectCSSVars__ = function __injectCSSVars__() {
  _useCssVars(function (_ctx) {
    return {
      "1c26b81e": _ctx.cardPictureWidth.height,
      "1a83cbef": _ctx.cardPictureWidth.width
    };
  });
};

var __setup__ = __default__.setup;
__default__.setup = __setup__ ? function (props, ctx) {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;